import * as Yup from 'yup';

export async function validate(data) {
  try {
    const schema = Yup.object().shape({
      name: Yup.string().required('Este campo é obrigatório'),
      description: Yup.string().required('Este campo é obrigatório'),
      parameter: Yup.string().required('Este campo é obrigatório'),
      value: Yup.string().required('Este campo é obrigatório'),
    });

    await schema.validate(data, { abortEarly: false });

    return data;
  } catch (error) {
    const errorMessages = {};

    if (error instanceof Yup.ValidationError) {
      error.inner.forEach(err => {
        if (!errorMessages[err.path]) errorMessages[err.path] = err.message;
      });
    }

    return { errorMessages };
  }
}
